import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=68733e70&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=68733e70&prod&lang=css"
import style1 from "./agreement.vue?vue&type=style&index=1&id=68733e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68733e70",
  null
  
)

export default component.exports